module.exports = __webpack_public_path__ + "static/img/cont3004.d8b2dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3004.jpg
// module id = Iw9P
// module chunks = 0